




import Vue, { PropType } from "vue";
import ice from "../../lib/ice";

export default Vue.extend({
  name: "vc-cancel-trial-button",
  props: {},
  methods: {
    onClickButton(e: Event) {
      ice.cancelTrial();
      e.preventDefault();
    }
  }
});
